module.exports = __webpack_public_path__ + "static/media/unit 5-7.1e5b8d48.jpg";